import React from 'react';
import clsx from 'clsx';
import { EnterPressHandler, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import formatDate from '@smart-tv/utils/date/format-date';
import { Device } from '@smart-tv/components/player/player-devices/types';
import testIds from '@smart-tv/e2e/shared/variables';

import Typography from '@smart-tv/components/typography';

import styles from './player-devices-dialog.module.scss';

interface Props {
  device: Device;
  onEnterPress: EnterPressHandler;
  onClick: (uids: string[]) => void;
}

export const PlayerDevicesDialogEditScreenDevicesItem: React.FC<Props> = (props: Props) => {
  const { device, onEnterPress, onClick } = props;

  const { name, lastUsedDate, active } = device;

  const { ref, focused } = useFocusable({ onEnterPress, focusable: !active });

  const rootClass = clsx(styles['player-devices-dialog-edit-screen-devices-item'], {
    [styles['player-devices-dialog-edit-screen-devices-item--focused']]: focused,
    [styles['player-devices-dialog-edit-screen-devices-item--disabled']]: active
  });

  return (
    <div ref={ref} className={rootClass} onClick={() => !active && onClick([device.uid])}>
      <div className={styles['player-devices-dialog-edit-screen-devices-item__text']}>
        <Typography component="div" fontWeight="bold">
          {name}
        </Typography>
        <Typography component="div" variant="caption2">
          {lastUsedDate
            ? `Senest anvendt ${formatDate(lastUsedDate, 'dd-MM-y')}`
            : 'Senest anvendt: ikke tilgængelig'}
        </Typography>
      </div>

      <Typography variant="caption" data-testid={testIds.player.tv2Dialog.removeDeviceButton}>
        {active ? 'Afspiller' : 'Fjern'}
      </Typography>
    </div>
  );
};

export default React.memo(PlayerDevicesDialogEditScreenDevicesItem);
